// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_a0-4";
export var collapsed = "_a0-1";
export var headerBar = "_a0-0";
export var leftHeaderContent = "_a0-3";
export var subjectContainer = "_a0-2";